<template>
  <div class="evento-ganadores">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Datos del Evento">
          <b-form>
            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cliente"
                :value="clienteNombre"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Evento"
              label-for="evento"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="evento"
                :value="eventoNombre"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
          <b-card header="Listado de Ganadores">
            <b-table hover
                responsive="sm" 
                class="registro"
                :busy="tableBusy"
                :items="ganadores" 
                :fields="ganadoresFields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(fechaNacimiento)="data">
                {{ data.item.fechaNacimiento | fecha }}
              </template>
              <template v-slot:cell(esCliente)="data">
                {{ data.item.esCliente? 'Si' : 'No' }}
              </template>
              <template v-slot:cell(staff)="data">
                {{ data.item.staff? 'Si' : 'No' }}
              </template>
            </b-table>
            <nav>
              <b-pagination size="sm" 
                :total-rows="totalRegistros" 
                :per-page="registrosPorPagina" 
                v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
            </nav>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item 
              @click.stop="exportGanadores">
            <i class="fa fa-file-excel-o"></i>Exportar Listado de Ganadores</b-dropdown-item>

          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
// import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import exportXLSSorteo from '../../mixins/export_xls_sorteo';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'eventoGanadores/getField',
  mutationType: 'eventoGanadores/updateField',
});

export default {
  name: 'Ganadores',
  components: {
    // appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
    exportXLSSorteo 
  ],
  data: () => {
    return {
      eventoId: 0,

      ganadoresFields: [
        { 
          key: 'posicionSorteo',
          label: 'Posición',
        },
      ],

      tableBusy: false,
      labelCols: 2,
      labelColsOpciones: 0
    }
  },
  computed: {
    ...mapFields([
      'evento',
      'clienteNombre',
      'eventoNombre',
      'tipoEventoId',
      'ganadores',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
    ]),
  },
  created() {
    if (this.$route.params){
      if (this.$route.params.eventoId){
        this.eventoId = this.$route.params.eventoId;
      }
    }

    this.showSpinner();
    this.$store.dispatch('eventoGanadores/inicializar', this.eventoId)
      .then(() => {
        this.formatoGrilla();
        this.getItems();
      })
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner())
  },  
  methods: {
    formatoGrilla() {
      switch (this.tipoEventoId) {
        case 3: /* Whapp*/
          this.ganadoresFields = [
            { 
              key: 'posicionSorteo',
              label: 'Posición',
            },
            { 
              key: 'nombreCompleto',
              label: 'Nombre'
            },
            { 
              key: 'documentoNumero',
              label: 'Nro.Documento'
            },
            { 
              key: 'fechaNacimiento',
              label: 'Fecha Nacim.'
            },
            { 
              key: 'numeroCelular',
              label: 'Nro.Celular'
            },
            { 
              key: 'email' 
            },
          ];
          break;

        default:
          this.ganadoresFields = [
            { 
              key: 'posicionSorteo',
              label: 'Posición',
            },
            { 
              key: 'nombreCompleto',
              label: 'Nombre'
            },
            { 
              key: 'documentoNumero',
              label: 'Nro.Documento'
            },
            { 
              key: 'fechaNacimiento',
              label: 'Fecha Nacim.'
            },
            { 
              key: 'numeroCelular',
              label: 'Nro.Celular'
            },
            { 
              key: 'email' 
            },
            { 
              key: 'esCliente',
              label: 'Cliente',
              class: 'text-center'
            },
            { 
              key: 'numeroCliente',
              label: 'Nro.Cliente'
            },
          ];
        break;
      }
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('eventoGanadores/getGanadores')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    goBack() {
      this.$router.go(-1);
    },
    exportGanadores() {
      this.showSpinner();
      this.$store.dispatch('eventoGanadores/getList')
        .then(() => {
          let exportar = false;
          let ganadores = this.$store.getters['eventoGanadores/list'];

          if (ganadores) {
            if (ganadores.length != 0) {
              exportar = true;
            }
          }

          if (exportar) {
            this.exportXLSListadoGanadores(this.eventoId, ganadores);
          } else {
            this.showErrorMsj('Se produjo un error al recuperar la información de los ganadores.');
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
  .evento-ganadores .registro table td[aria-colindex="1"] {
    width: 5%;
  }
  .evento-ganadores .registro table td[aria-colindex="2"] {
    width: 30%;
  }
  .evento-ganadores .registro table td[aria-colindex="3"] {
    width: 10%;
  }
  .evento-ganadores .registro table td[aria-colindex="4"] {
    width: 10%;
  }
  .evento-ganadores .registro table td[aria-colindex="5"] {
    width: 10%;
  }
  .evento-ganadores .registro table td[aria-colindex="6"] {
    width: 25%;
  }
  .evento-ganadores .registro table td[aria-colindex="7"] {
    width: 5%;
  }
  .evento-ganadores .registro table td[aria-colindex="8"] {
    width: 5%;
  }
</style>
